import Cookies from 'js-cookie';

export const handleLogout = async (username, setCurrentJiliStage) => {
    try {
        // Step 2: Update login state on the backend
        await fetch(process.env.REACT_APP_DATA_JSON_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                cmd: 'updateLoginState',
                username,
                isLoggedIn: false,
            }),
        });
    } catch (err) {
        console.error('Logout failed:', err);
    } finally {
        // Step 3: Clear session/local storage
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('recentGames');

        localStorage.removeItem('telegramBannerShown');

        setCurrentJiliStage?.(null);
        sessionStorage.removeItem('lotteryModalShown');
        Cookies.remove('doNotShowRecoveryHour');

        // Respect "remember me"
        const rememberMe = localStorage.getItem('rememberMe') === 'true';
        if (!rememberMe) {
            localStorage.removeItem('username');
            localStorage.removeItem('password');
        }

        // Step 4: Redirect
        window.location.href = '/';
    }
};
